/**
 * Saca de la URL los tokens de un solo uso.
 *
 * `/reset-password?token=…` y `/verify-email?token=…` llevaban el token en la
 * query string, y todo lo que mide la navegacion envia la URL entera: GA4 manda
 * `document.location` en cada `page_view`, y hasta hace poco el pixel de Meta
 * hacia lo mismo. Un token de recuperacion de contrasena acababa en un tercero.
 *
 * La URL ademas queda en el historial del navegador, en la cabecera `Referer` de
 * cualquier recurso externo que cargue la pagina, y en los logs de acceso de todo
 * lo que haya por delante (CDN incluido). Quitarlo de ahi lo arregla en todos esos
 * sitios a la vez, no solo en la analitica.
 *
 * El token pasa a `sessionStorage` en lugar de a memoria para que recargar la
 * pagina no rompa el flujo: en `/reset-password` la persona todavia tiene que
 * escribir la contrasena nueva, y perder el token a mitad la obligaria a pedir
 * otro correo. En sessionStorage no viaja a ningun sitio, muere al cerrar la
 * pestana, y quien pudiera leerlo (un XSS) tambien podria leer la URL: no se
 * pierde nada respecto a como estaba.
 */
const CLAVE = "qc_url_token";

const RUTAS_CON_TOKEN = new Set(["/reset-password", "/verify-email"]);

/**
 * Si la URL actual lleva token, lo guarda y lo borra de la barra de direcciones.
 *
 * Se llama en dos sitios a proposito: en `index.js` antes de montar nada — y por
 * tanto antes de que se cargue gtag — y desde las propias paginas, porque en la
 * app nativa los enlaces profundos entran por `navigate()` y no vuelven a pasar
 * por `index.js`.
 */
export function capturarTokenDeUrl() {
    try {
        if (!RUTAS_CON_TOKEN.has(window.location.pathname)) return "";
        const params = new URLSearchParams(window.location.search);
        const token = params.get("token");
        if (!token) return "";

        sessionStorage.setItem(CLAVE, token);
        params.delete("token");
        const query = params.toString();
        window.history.replaceState(
            window.history.state,
            "",
            window.location.pathname + (query ? `?${query}` : "") + window.location.hash,
        );
        return token;
    } catch (_e) {
        return "";
    }
}

/** El token de la URL, ya sea porque acaba de llegar o porque se guardo antes. */
export function leerTokenDeUrl() {
    const recienLlegado = capturarTokenDeUrl();
    if (recienLlegado) return recienLlegado;
    try {
        return sessionStorage.getItem(CLAVE) || "";
    } catch (_e) {
        return "";
    }
}

/** Se llama cuando el token ya se ha gastado: no tiene por que sobrevivir. */
export function olvidarTokenDeUrl() {
    try {
        sessionStorage.removeItem(CLAVE);
    } catch (_e) {}
}
